import { render, staticRenderFns } from "./ValuesSelection.vue?vue&type=template&id=7273c978&scoped=true&"
import script from "./ValuesSelection.vue?vue&type=script&lang=js&"
export * from "./ValuesSelection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7273c978",
  null
  
)

export default component.exports